var _rect, _g, _rect2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "url(#paint0_linear_169_159)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_169_159)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.23145,
    y: 24,
    width: 32.6987,
    height: 20.4367,
    rx: 10.2183,
    fill: "url(#paint1_linear_169_159)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.23999,
    y: 6.24023,
    width: 35.4236,
    height: 35.4236,
    rx: 17.7118,
    fill: "url(#paint2_linear_169_159)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_169_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5749 32.4759V20.6039H14.6323V32.4759H18.5753H18.5749ZM16.6044 18.9832C17.979 18.9832 18.8347 18.0716 18.8347 16.9323C18.809 15.7671 17.979 14.8809 16.6306 14.8809C15.2812 14.8809 14.3999 15.7671 14.3999 16.9322C14.3999 18.0715 15.2554 18.9831 16.5786 18.9831H16.6041L16.6044 18.9832ZM20.7572 32.4759H24.6994V25.8468C24.6994 25.4924 24.7252 25.1371 24.8293 24.884C25.1142 24.1748 25.7629 23.4407 26.8523 23.4407C28.2785 23.4407 28.8494 24.5293 28.8494 26.1254V32.4759H32.7916V25.6689C32.7916 22.0224 30.8468 20.3255 28.253 20.3255C26.1264 20.3255 25.1924 21.5152 24.6735 22.3255H24.6997V20.6043H20.7574C20.8088 21.718 20.7571 32.4764 20.7571 32.4764L20.7572 32.4759Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_169_159",
    x: 1.77145,
    y: 18.54,
    width: 43.6187,
    height: 31.3575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_169_159"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_169_159",
    x: 12.96,
    y: 12.9609,
    width: 21.6,
    height: 22.0996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_169_159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_159",
    x1: 4.03493,
    y1: 3.1441,
    x2: 39.6681,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDDE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_159",
    x1: 25.8407,
    y1: 45.0462,
    x2: 19.1756,
    y2: 21.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058CCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_159",
    x1: 26.4,
    y1: 42.7202,
    x2: 9.83999,
    y2: 6.24023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058CCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.5b8bef01a5a90425e30b12652b8c73fd.svg";
export { ForwardRef as ReactComponent };